//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteMN from './expedienteMateriasN'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteMN />
            </div>
        );
    }

}
export default Index;